<template>
  <div :class="{'animationComplete' : animationComplete}">
    <BackgroundFader class="blurable" ref="bgFader" :content="images" @complete="animationComplete = true;"/>
    <PageWrapper class="blurable">

      <InfoBlock :subTitle="gd[currentScenario].subTitle" :title="gd[currentScenario].title" :content="gd[currentScenario].steps[currentStep]"/>

      <Button btnContent="Replay animation" iconType="replay" @click="replay" class="replayButton reveal" />
      
      <Button class="scenarioNextButton" btnContent="Next step" iconType="arrow" @click="$router.push('step6')"/>
      <Button class="scenarioPreviousButton" iconType="arrow" @click="$router.push('step4')"/>
      <Button btnContent="Gallery" @click="openGallery" class="galleryButton" />
    
    </PageWrapper>

    <HotspotsWrapper class="blurable reveal">
      <Hotspot x="1200" y="450" @click="openModel('modelWindow1')"/>
      <Hotspot x="960" y="250" @click="openModel('modelWindow2')"/>
    </HotspotsWrapper>

    <ModelWindow ref="modelWindow1" :image="require('@/assets/images/hotspots/sPad.png')">
      <h1>Personal Area Detection (PAD)</h1>
      <p>Saab’s dismounted CBRN Automatic Warning and Reporting (AWR) unit enhances early detection of threats.</p>
      <p>It comes with Saab’s Soldier System, a rugged display and computer that provides individuals with PC-compatible interfaces and the ability to interconnect with any field radio.</p>
    </ModelWindow>

    <ModelWindow ref="modelWindow2" :image="require('@/assets/images/hotspots/CBRN_Vehicle.png')">
      <h1>Recce Area Detection (RAD)</h1>
      <p>Saab’s CBRN recce vehicle is a complete CBRN reconnaissance vehicle and first responder unit, carrying specialists with advanced detection, identification and sampling equipment.</p>
      <p>It provides active detection equipment, enabling users to monitor the outside air from their workstations.</p>
      <p>The vehicle is equipped with protective suits, masks and detection instruments, and carries equipment capable of substance identification and safe personnel decontamination.</p>
    </ModelWindow>

    <GalleryModal ref="galleryModal" :content="galleryImages"/>
  </div>
</template>


<script>
import PageWrapper from '@/components/PageWrapper';
import InfoBlock from '@/components/InfoBlock';
import AutoStep from '@/components/AutoStep';
import Button from '@/components/Button';
import ModelWindow from "@/components/ModelWindow";
import HotspotsWrapper from '@/components/HotspotsWrapper';
import Hotspot from '@/components/Hotspot';
import BackgroundFader from "@/components/BackgroundFader";
import gd from "@/assets/stores/globalDS.js";
import GalleryModal from '@/components/paul/GalleryModal';

export default {
  components: {
    PageWrapper,
    InfoBlock,
    AutoStep,
    Button,
    ModelWindow,
    HotspotsWrapper,
    Hotspot,
    BackgroundFader,
    GalleryModal
  },
  data() {
    return {
      gd: gd,
      animationComplete: false,
      images: [
        'biological/6-1.jpg',
        'biological/6-2.jpg',
        'biological/6-3.jpg',
        'biological/6-4.jpg',
        'biological/6-5.jpg',
        'biological/6-6.jpg',
        'biological/6-7.jpg',
        'biological/6-8.jpg',
        'biological/6-9.jpg',
        'biological/6-10.jpg',
        'biological/6-11.jpg',
        'biological/6-12.jpg'
      ],
      galleryImages: gd.gallery.biological
    }
  },
  computed: {
    appPath() {
      return this.$router.currentRoute.fullPath.split("/");
    },
    currentStep() {
      return this.appPath[this.appPath.length - 1];
    },
    currentScenario() {
      return this.appPath[this.appPath.length - 2];
    }
  },
  methods: {
    replay() {
      this.animationComplete = false;
      this.$refs.bgFader.reset();
    },
    openModel: function(modelWindow) {
      this.$refs[modelWindow].openModel();
    },
    openGallery: function() {
      this.$refs.galleryModal.openModal();
    }
  }
}
</script>

